<template>
  <div class="app-container">
    <!-- <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive> -->
    <router-view></router-view>
  </div>
</template>
<script>
import {getDevice} from '@/utils'

export default {
  name: 'App',
  data () {
    return {
    }
  },
  created () {
    // const loading = document.querySelector('#appLoading')
    // loading && document.body.removeChild(loading)

    this.$store.dispatch('app/initEnv', getDevice())
  }
}
</script>

<style lang="scss" scoped>
  .app-container {
    width: 100%;
    height: 100vh;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue